export default {
    'name': 'close',
    'width': '16',
    'height': '16',
    'viewBox': '0 0 16 16',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M12.1769 5.0203C12.3721 4.82504 12.3721 4.50846 12.1769 4.31319C11.9816 4.11793 11.665 4.11793 11.4698 4.31319L8.24503 7.53792L5.0203 4.31319C4.82504 4.11793 4.50846 4.11793 4.31319 4.31319C4.11793 4.50846 4.11793 4.82504 4.31319 5.0203L7.53792 8.24503L4.31319 11.4698C4.11793 11.665 4.11793 11.9816 4.31319 12.1769C4.50846 12.3721 4.82504 12.3721 5.0203 12.1769L8.24503 8.95214L11.4698 12.1769C11.665 12.3721 11.9816 12.3721 12.1769 12.1769C12.3721 11.9816 12.3721 11.665 12.1769 11.4698L8.95214 8.24503L12.1769 5.0203Z\' fill=\'#42A463\'/>'
}
